import { render, staticRenderFns } from "./ExploreAvailableProducts.vue?vue&type=template&id=bdd5581e"
import script from "./ExploreAvailableProducts.vue?vue&type=script&lang=js"
export * from "./ExploreAvailableProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports